// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PmEC","delete":"styles_delete__3bvgZ","update":"styles_update__3vYl3","add":"styles_add__n_Bmn"};